module.exports = __webpack_public_path__ + "media/images/smart_phone/item/cart_btn_ov-c50c127c33bc0774d15280f6627ac9d0.gif";